import c from 'classnames';
import _s from './index.module.scss';
import Banner from '@/components/banner';
import { Map, APILoader, Marker} from '@uiw/react-amap';


const Contact = () => {
  return (
    <>
    <Banner name='联系我们' />
    <div className={_s.wrap}>
      <section className={c(_s.main)}>
        <div className={_s.contact}>
          <div className={_s.card}>
            <div className={_s.icon}></div>
            <p><span>地　址：</span>上海市静安区成都北路333号招商局广场南楼1606室</p>
            <p><span>电　话：</span>021-52666106 / 17721158192</p>
            <p><span>邮　箱：</span>lul@ipjianding.com</p>
            <p><span>联系人：</span>陆女士</p>
            <p><span>网　址：</span>www.ipjianding.com</p>
          </div>
        </div>
        <div className={c(_s.map)}>
          <div className={_s.mapDiv}>
            <APILoader akey="decfe3d4a94d70f7d48469c56b463a7a">
              <Map
                dragEnable
                zoom={15}
                center={[121.466396,31.227937]}
                viewMode='2D'
              >
                <Marker visiable title="招商局广场南楼1606室" position={[121.466396,31.227937]} />
              </Map>
            </APILoader>
          </div>
        </div>
      </section>
    </div></>
  )
}

export default Contact;